<template>
  <div>
    <div class="title">
      <div class="title-img" v-if="img1">
        <img :src="img1" alt srcset1 class="title-img-img"/>
      </div>
      <div class="title-context">
        <div class="title-context1">{{ form.name }}</div>
        <div class="title-context2">负责人：{{ form.personCharge }}</div>
        <div class="title-context3">电话：{{ form.contact }}</div>
        <div class="title-context4">地址：{{ form.address }}</div>
      </div>
    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="margin-top:30px">
      <el-tab-pane label="基本信息" name="first">
        <el-form v-if="activeName=='first'" ref="form" :model="form" label-width="140px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="机构名称">
                <el-input v-model="form.mechanismName"></el-input>
              </el-form-item>
              <el-form-item label="负责人" prop="personCharge">
                <el-input v-model="form.personCharge"></el-input>
              </el-form-item>

            </el-col>
            <el-col :span="12">
              <el-form-item label="机构类型" prop="mechanismType">
                <el-select v-model="form.mechanismType" style="width:100%">
                  <el-option label="机构养老" :value="1"></el-option>
                  <el-option label="社区养老" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="联系电话" prop="contact">
                <el-input v-model="form.contact"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="地址">
            <el-input v-model="form.address" style="width:500px"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remarks">
            <el-input type="textarea" v-model="form.remarks"></el-input>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="工作人员" name="second">
        <el-row v-if="activeName=='second'">
          <el-col :span="24">
            <el-carousel :interval="115000" type="card" height="350px;width: 33%;">
              <el-carousel-item v-for="(item,index) in imgList" :key="index">
                <div class="item-img">
                  <div class="img-div">
                    <img :src="item.img" alt="" style="width: 100%;height: 100%">
                  </div>
                  <div style="text-align: center;margin-bottom: 10px">{{ item.name }}</div>
                  <div style="text-align: center;margin-bottom: 10px">{{ item.post }}</div>
                  <el-tooltip placement="top">
                    <div slot="content" style="width: 600px;line-height: 24px">{{ item.introduce }}</div>
                    <div style="text-align: center;margin-bottom: 10px">{{ item.introduce }}</div>
                  </el-tooltip>

                </div>
              </el-carousel-item>
            </el-carousel>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="活动室信息" name="third">
        <el-row v-if="activeName=='third'">
          <el-col :span="24">
            <el-carousel :interval="5000" type="card" height="350px" style="width:100%">
              <el-carousel-item v-for="(item,index) in imgList1" :key="index">
                <div class="item-img">
                  <div class="img-div">
                    <img :src="item.img" alt="" style="width: 100%;height: 100%; margin: 0px auto;">
                  </div>
                  <div style="text-align: center;margin-bottom: 10px">{{ item.activityRoomName }}</div>
                  <div style="text-align: center;margin-bottom: 10px">{{ item.area }}m²</div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="服务产品" name="fourth">
        <div class="title-right">
          <div class="myChart-title">
            <div class="myChart-item">
              服务大项<span style="font-size: 24px;margin: 0px 10px">5</span>项
            </div>
            <div class="myChart-item">
              服务大项<span style="font-size: 24px;margin: 0px 10px">5</span>项
            </div>
            <div class="myChart-item">
              服务大项<span style="font-size: 24px;margin: 0px 10px">5</span>项
            </div>
          </div>
          <div id="myChart" style="width:100%;height: 400px"></div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// import img1 from "@/assets/images/map/1.jpg";
import {
  communityActiveList,
  communityInfoCheck,

  communityPeopleList,
  organizationServingProductList,
  communityServeProductList
} from "../api/index";

export default {
  components: {},
  props: {
    row: {
      type: Object,
    }
  },
  data() {
    return {
      img1: '',
      currentPage4: 1,
      activeName: "first",
      form: {},
      form1: {},
      form2: {},
      form3: {},
      tableData: [
        {
          date: "医疗保健",
          name: "健康体检",
          address: "50元/次",
          address1: "定期组织老人全面体检，建立老人健康档案",
        },
        {
          date: "医疗保健",
          name: "晒太阳",
          address: "120元/次",
          address1: "每天定时帮助老人到院子里晒太阳30分钟",
        },
        {
          date: "洗护",
          name: "帮助洗澡",
          address: "100元/次",
          address1: "打扫卫生",
        },
        {
          date: "整理",
          name: "整理房间",
          address: "70元/次",
          address1: "整理房间被褥、桌椅",
        },
      ],
      total: 0, //总数据
      pageNo: 1,
      pageSize: 10,
      fileList: [],
      imgList: [],
      imgList1: [],
    };
  },
  methods: {

    //切换
    handleClick(tab, event) {
      if (this.activeName == 'fourth') {
        this.getData3({mechanismId: this.row.id})
        this.$nextTick(() => {
          setTimeout(() => {
            this.drawLine()
          }, 500)

        })
      } else if (this.activeName == 'first') {
        this.getData({id: this.row.id})
      } else if (this.activeName == 'second') {
        // this.$nextTick(() => {
        //     setTimeout(() => {
        //         this.drawLine()
        //     }, 500)
        // })
        this.getData1({mechanismId: this.row.id})
      } else if (this.activeName == 'third') {
        // this.$nextTick(() => {
        //     setTimeout(() => {
        //         this.draw()
        //     }, 500)
        // })
        this.getData2({mechanismId: this.row.id})
      }
    },

    //回写拿到基本数据
    getData(e) {
      return new Promise(resolve => {
        communityInfoCheck(e).then(res => {
          resolve(res)
        });
      })
    },
    //回写工作人员拿到数据
    getData1(e) {
      let params = Object.assign({}, e, {
        pageNo: 1,
        pageSize: 1000
      })
      return new Promise(resolve => {
        communityPeopleList(params).then((res) => {
          resolve(res)
        });
      })
    },
    //回写拿到数据
    getData2(e) {
      let params = Object.assign({}, e, {
        pageNo: 1,
        pageSize: 1000
      })
      return new Promise(resolve => {
        communityActiveList(params).then(res => {
          resolve(res)
        });
      })

    },
    //回写拿到服务数据
    getData3(e) {
      let params = Object.assign({}, e, {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      })
      return new Promise(resolve => {
        communityServeProductList(params).then((res) => {
          this.tableData = res.content.list
          this.total = res.content.count;
          resolve(res)
        });
      })
    },
    drawLine() {
      let that = this
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        title: {text: ""},
        tooltip: {},
        xAxis: {
          data: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
          textStyle: {
            color: "akyblue",
          },
        },
        yAxis: {
          axisLabel: {
            textStyle: {
              color: "#999",
            },
          },
        },
        series: [
          {
            name: "销量",
            type: "bar",
            data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            itemStyle: {
              normal: {
                color: "#4ad2ff",
              },
            },
          },
        ],
      });
    },
  },
  async mounted() {
    let arr = await this.getData({id: this.row.id})
    let arr1 = await this.getData1({mechanismId: this.row.id})
    let arr2 = await this.getData2({mechanismId: this.row.id})
    let arr3 = await this.getData3({mechanismId: this.row.id})
    this.form = arr.content;
    this.form1 = arr1.content;
    this.form2 = arr2.content;
    this.form3 = arr3.content;
    if (this.form.photo) {
      let imgItem = this.form.photo.split(";");
      imgItem.pop()
      this.img1 = imgItem[0]
    }
    let imgList = []
    this.form1.list.forEach(item => {
      if (item.photo) {
        let imgItem = item.photo.split(";");
        imgItem.pop()
        imgList.push({img: imgItem[0], name: item.name, post: item.post, introduce: item.introduce})
      }
    })

    this.imgList = imgList


    let imgList1 = []
    this.form2.list.forEach(item => {
      if (item.photo) {
        let imgItem = item.photo.split(";");
        imgItem.pop()
        imgList1.push({img: imgItem[0], activityRoomName: item.activityRoomName, area: item.area})
      }
    })
    this.imgList1 = imgList1

    // this.$nextTick(() => {
    //     setTimeout(() => {
    //         this.drawLine()
    //         this.draw()
    //     }, 500)
    //
    // })

  },
};
</script>

<style scoped>
#myChart {
  width: 100%;
  height: 400px;
}

#myChart1 {
  width: 100%;
  height: 400px;
}

#chart {
  width: 500px;
  height: 400px;
  margin: 0px auto;
}

#chart1 {
  width: 100%;
  height: 400px;
}

.title {
  display: flex;
}

.myChart-title {
  display: flex;
  height: 80px;
  font-size: 16px;
  justify-content: space-between;
}

.myChart-item {
  width: 30%;
  height: 100%;
  background-color: rgba(58, 161, 255);
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFF;
}

.title-img-img {
  width: 100%;
  height: 100%;

}

.title-img {
  width: 265px;
  height: 170px;
}

.title-context {
  width: 70%;
  height: 170px;
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.title-context1 {
  font-size: 26px;
}

.title-context2,
.title-context3,
.title-context4 {
  font-size: 16px;
}

.top1-circle-right-item-circle {
  width: 5px;
  height: 5px;
  display: inline-block;
}

.third-center {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-div {
  width: 150px;
  height: 200px;
  /*background-color: blue;*/
  margin: 20px 0px;
}

.item-img {
  width: 100%;
  height: 100%;
  /*background-color: red;*/
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.el-carousel__item h3 {
  color: #FFF;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #FFF;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #FFF;
}
</style>
